exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._JcqLIxCFFJPdxHvHJiCD{display:flex;margin-bottom:30px}._JcqLIxCFFJPdxHvHJiCD .IVhtNT5gWx54ksxw1Poya{margin:0px 10px;background:#fff;border:1px solid #bdbdbd;border-radius:5px;flex-grow:0;flex-shrink:1;padding:20px}._JcqLIxCFFJPdxHvHJiCD .IVhtNT5gWx54ksxw1Poya:first-child{margin-left:0px}._JcqLIxCFFJPdxHvHJiCD .IVhtNT5gWx54ksxw1Poya:last-child{margin-right:0px}._JcqLIxCFFJPdxHvHJiCD .IVhtNT5gWx54ksxw1Poya._3xwYNEOi9QVZMmU222NY65{border:2px solid #fa6400}\n", ""]);

// Exports
exports.locals = {
	"BlockButtonGroup": "_JcqLIxCFFJPdxHvHJiCD",
	"groupItem": "IVhtNT5gWx54ksxw1Poya",
	"selected": "_3xwYNEOi9QVZMmU222NY65"
};